import WebFont from 'webfontloader';

document.addEventListener('DOMContentLoaded', () => {
  WebFont.load({
    google: {
      families: ['Poppins:400,600', 'Open Sans:400,600,700']
    },
  });
});